import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { FaBars, FaTimes, FaHome, FaCalendarAlt, FaUserFriends, FaListUl, FaSignOutAlt, FaUser, FaStar, FaTrashAlt } from "react-icons/fa";
import { useSalon } from "../../context/SalonContext";
import LogoutModal from "../logout/LogoutModal";
import DeleteAccountModal from "../deleteAccount/DeleteAccountModal";
import "./Header.css";
import { toast } from "react-toastify";
import NotificationBell from "../notifications/NotificationBell";

export default function Header() {
    const [menuOpen, setMenuOpen] = useState(false);
    const [showLogoutModal, setShowLogoutModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();

    const { customerName, logout, membershipCount, salonName } = useSalon();

    const closeMenu = () => setMenuOpen(false);

    const confirmLogout = () => {
        logout();
        setMenuOpen(false);
        setShowLogoutModal(false);
        toast.info("👋 You have logged out successfully");
        navigate("/login");
    };

    // Helper to determine if a link is active
    const isActive = (path) => location.pathname === path;

    return (
        <>
            <header className="premium-header">
                <nav className="header-nav">
                    <div className="header-left">
                        <Link to="/home" className="brand-link">
                            <span className="brand-text">{salonName || "Salon Booking"}</span>
                            <div className="brand-diamond">♦</div>
                        </Link>
                    </div>

                    <div className="header-right">
                        {customerName && (
                            <div className="desktop-user-info">
                                <span className="greeting-pill">
                                    <FaUser className="me-2" /> Hi, {customerName}
                                </span>
                            </div>
                        )}

                        <div className="notification-icon-wrapper">
                            <Link to="/notifications" className="nav-icon-link">
                                <NotificationBell customerId={localStorage.getItem("CUSTOMER_ID")} />
                            </Link>
                        </div>

                        <button className="menu-toggle-btn" onClick={() => setMenuOpen(!menuOpen)}>
                            {menuOpen ? <FaTimes /> : <FaBars />}
                        </button>
                    </div>
                </nav>

                {/* Sidebar Drawer */}
                <div className={`sidebar-drawer ${menuOpen ? "open" : ""}`}>
                    <div className="drawer-header">
                        <div className="user-profile-summary">
                            <div className="avatar-circle">
                                {customerName ? customerName.charAt(0).toUpperCase() : <FaUser />}
                            </div>
                            <div className="user-details">
                                <p className="user-name">{customerName || "Welcome"}</p>
                                <p className="user-sub">{customerName ? "Premium Member" : "Guest User"}</p>
                            </div>
                        </div>
                    </div>

                    <div className="drawer-body">
                        <div className="nav-group">
                            <Link to="/home" className={`drawer-link ${isActive('/home') ? 'active' : ''}`} onClick={closeMenu}>
                                <FaHome className="drawer-icon" /> Home
                            </Link>
                            <Link to="/booking" className={`drawer-link ${isActive('/booking') ? 'active' : ''}`} onClick={closeMenu}>
                                <FaUserFriends className="drawer-icon" /> {salonName || "My Salon"}
                            </Link>
                            <Link to="/loyaltyWallet" className={`drawer-link ${isActive('/loyaltyWallet') ? 'active' : ''}`} onClick={closeMenu}>
                                <FaCalendarAlt className="drawer-icon" /> Loyalty Rewards
                            </Link>
                            <Link to="/viewBookings" className={`drawer-link ${isActive('/viewBookings') ? 'active' : ''}`} onClick={closeMenu}>
                                <FaCalendarAlt className="drawer-icon" /> My Appointments
                            </Link>
                            <Link to="/reviews" className={`drawer-link ${isActive('/reviews') ? 'active' : ''}`} onClick={closeMenu}>
                                <FaStar className="drawer-icon" /> Salon Reviews
                            </Link>
                        </div>

                        <div className="nav-divider"></div>

                        <div className="nav-group">
                            <Link to="/membership-plans" className={`drawer-link ${isActive('/membership-plans') ? 'active' : ''}`} onClick={closeMenu}>
                                <FaListUl className="drawer-icon" /> Membership Plans
                            </Link>
                            <Link to="/my-memberships" className={`drawer-link ${isActive('/my-memberships') ? 'active' : ''}`} onClick={closeMenu}>
                                <FaListUl className="drawer-icon" /> My Memberships
                                {membershipCount > 0 && <span className="count-badge">{membershipCount}</span>}
                            </Link>
                        </div>

                        {customerName && (
                            <>
                                <div className="nav-divider"></div>
                                <div className="nav-group">
                                    <button
                                        className="drawer-link text-danger border-0 bg-transparent w-100 text-start cursor-pointer"
                                        onClick={() => {
                                            closeMenu();
                                            setShowDeleteModal(true);
                                        }}
                                    >
                                        <FaTrashAlt className="drawer-icon text-danger" /> Delete Account
                                    </button>
                                </div>
                            </>
                        )}
                    </div>

                    <div className="drawer-footer">
                        {!customerName ? (
                            <Link to="/login" className="drawer-auth-btn login" onClick={closeMenu}>
                                Sign In
                            </Link>
                        ) : (
                            <>
                                <button
                                    className="drawer-auth-btn delete-account mb-2"
                                    onClick={() => {
                                        closeMenu();
                                        setShowDeleteModal(true);
                                    }}
                                >
                                    <FaTrashAlt className="me-2" /> Delete Account
                                </button>
                                <button
                                    className="drawer-auth-btn logout"
                                    onClick={() => {
                                        closeMenu();
                                        setShowLogoutModal(true);
                                    }}
                                >
                                    <FaSignOutAlt className="me-2" /> Logout
                                </button>
                            </>
                        )}
                    </div>
                </div>

                {menuOpen && <div className="drawer-overlay" onClick={closeMenu}></div>}
            </header>

            <LogoutModal
                show={showLogoutModal}
                onClose={() => setShowLogoutModal(false)}
                onConfirm={confirmLogout}
            />

            <DeleteAccountModal
                show={showDeleteModal}
                onClose={() => setShowDeleteModal(false)}
            />
        </>
    );
}
